import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Column from '../../../bootstrap/component/Column'
import Row from '../../../bootstrap/component/Row'
import LabelInput from '../../../form/component/LabelInput'
import Input from '../../../form/component/Input'
import currentUserHasAccess from '../../../../util/widget-helper'
import { TREATMENT_DURATION_WIDGET_CONTAINER } from '../../../process/ui-definition/process-ui'
import Select from '../../../form/component/Select'
import { ALIGNER_SYSTEM_DEFAULT_VALUE } from '../../state/quotation/const'


const TreatmentDuration = ({ treatmentPlan, alignerSystemList, alignersPerStepList, changeTreatmentPlan, saveTreatmentPlan, readOnly }) => {
    if (!currentUserHasAccess(TREATMENT_DURATION_WIDGET_CONTAINER)) {
        return null
    }

    if (!treatmentPlan) {
        return null
    }

    if (!treatmentPlan.system) {
        changeTreatmentPlan('system', ALIGNER_SYSTEM_DEFAULT_VALUE)
    }

    const updateNumberOfAligner = (name, numberOfSteps, system) => {
        const numberOfAlignerPerStep = alignersPerStepList[system]
        changeTreatmentPlan(name, numberOfSteps * numberOfAlignerPerStep)
    }

    return (
        <div className="instructions w-treatment-duration">
            <ContentBox title="Number of aligners">
                <Row className="w-td-panel">
                    <Column className="w-td-column w-td-inputs">
                        <div className="w-td-input-top">
                            <LabelInput label="System">
                                <Select
                                    name="system"
                                    valueList={alignerSystemList}
                                    onChange={(name, value) => {
                                        changeTreatmentPlan(name, value)
                                        updateNumberOfAligner('numberOfAlignerUpperJaw', treatmentPlan.numberOfStepsUpperJaw, value)
                                        updateNumberOfAligner('numberOfAlignerLowerJaw', treatmentPlan.numberOfStepsLowerJaw, value)
                                        saveTreatmentPlan()
                                    }}
                                    readOnly={readOnly}
                                    object={treatmentPlan}
                                    defaultValue={ALIGNER_SYSTEM_DEFAULT_VALUE}
                                />
                            </LabelInput>
                            <LabelInput label="Steps upper jaw">
                                <Input
                                    name="numberOfStepsUpperJaw"
                                    onChange={(name, value) => {
                                        changeTreatmentPlan(name, value)
                                        updateNumberOfAligner('numberOfAlignerUpperJaw', value, treatmentPlan.system)
                                    }}
                                    onBlur={saveTreatmentPlan}
                                    type="number"
                                    readOnly={readOnly}
                                    object={treatmentPlan}/>
                            </LabelInput>
                            <LabelInput label="Number of aligner upper jaw">
                                <Input
                                    name="numberOfAlignerUpperJaw"
                                    type="number"
                                    readOnly={true}
                                    object={treatmentPlan}/>
                            </LabelInput>
                        </div>
                        <div className="w-td-input-bottom">
                            <LabelInput label="Steps lower jaw">
                                <Input
                                    name="numberOfStepsLowerJaw"
                                    onChange={(name, value) => {
                                        changeTreatmentPlan(name, value)
                                        updateNumberOfAligner('numberOfAlignerLowerJaw', value, treatmentPlan.system)
                                    }}
                                    onBlur={saveTreatmentPlan}
                                    type="number"
                                    readOnly={readOnly}
                                    object={treatmentPlan}/>
                            </LabelInput>
                            <LabelInput label="Number of aligner lower jaw">
                                <Input
                                    name="numberOfAlignerLowerJaw"
                                    type="number"
                                    readOnly={true}
                                    object={treatmentPlan}/>
                            </LabelInput>
                        </div>
                    </Column>
                    <Column className="w-td-column">
                        <img src="/asset/image/teeth-universal-numbering-system.png" alt="teeth-universal-numbering-system"/>
                    </Column>
                </Row>
            </ContentBox>
        </div>
    )
}


TreatmentDuration.propTypes = {
    treatmentPlan: PropTypes.object,
    alignerSystemList: PropTypes.array,
    alignersPerStepList: PropTypes.any,
    changeTreatmentPlan: PropTypes.func,
    saveTreatmentPlan: PropTypes.func,
    readOnly: PropTypes.bool,
}

export default TreatmentDuration



// WEBPACK FOOTER //
// ./src/modules/treatment/component/plan/TreatmentDuration.js